export default __webpack_public_path__ + "static/media/wf_impact_isf_articles_us-mayors-climate-change_mobile.cf6f3dcb.jpg";